import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class AppConfig {

    public get isProduction() { return environment.production; }

    public getApiUrl(method: string) {
        let apiVersion = environment.apiVersion;
        let apiUrl = environment.apiUrl;
        return `${apiUrl}/${apiVersion}${method || ''}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts